import React from 'react';
import BasePopover from '../../component/popover/base-popover.component';
import { Box, Button, Typography } from '@mui/material';

/**
 * 溢出行显示按钮组件
 * @param props @param showData 显示的数据
 * @returns
 */
export function PopoverEllipsis(props: {
    // 要显示的数据
    showData?: string | JSX.Element;
    shortData?: string;
    className?: string;
}): JSX.Element {

    const { showData, className, shortData } = props;

    // 锚点开关
    const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

    return showData ? (
        <div style={{
            display: 'inline-block',
            // maxWidth: '100%',
            textAlign: 'center',
        }}>
            <div className='ellipsisBox'>
                <Box
                    className={`ellipsisTitle ${className}`}

                // onClick={(e) => e.stopPropagation()}
                >
                    {shortData || showData}
                </Box>
                <Button
                    variant='contained'
                    color='secondary'
                    className='ellipsisBtn'
                    onClick={(e) => {
                        e.stopPropagation();
                        setAnchorEl(e.currentTarget);
                    }}
                >
                    {'···'}
                </Button>
                <BasePopover
                    open={Boolean(anchorEl)}
                    anchorEl={anchorEl}
                    onClose={() => { setAnchorEl(null) }}
                    id='record-popover'
                >
                    <Typography sx={{ padding: '6px 10px', color: '#8FA4C2' }}>{showData}</Typography>
                </BasePopover>
            </div>
        </div>
    ) : <></>
}